var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocationSub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 6.94501C0.75 3.58003 3.4264 0.875 6.7 0.875C9.9736 0.875 12.65 3.58003 12.65 6.94501C12.65 8.67953 12.1511 10.5818 11.2547 12.2323C10.3568 13.8856 9.09257 15.2288 7.60763 15.9229C7.03113 16.1924 6.36887 16.1924 5.79237 15.9229C4.30743 15.2288 3.04321 13.8856 2.14533 12.2323C1.2489 10.5818 0.75 8.67953 0.75 6.94501Z",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.7,
    cy: 6.825,
    r: 1.7625,
    stroke: "#808080",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationSub);
export default __webpack_public_path__ + "static/media/icon_location_sub.eb0119e5fe9addbcbb10b63fd7f019dc.svg";
export { ForwardRef as ReactComponent };